// extracted by mini-css-extract-plugin
export default {"flag":"VoteProgress_flag__PBx9z","label":"VoteProgress_label__fZf1Q","line":"VoteProgress_line__qFbIS","track":"VoteProgress_track__mM4jj","item":"VoteProgress_item__diJyG"};